import React, { useEffect, useRef } from "react";
import { columnChart, registerTheme } from "tui-chart";
import "tui-chart/dist/tui-chart.css";

const theme = {
  title: { color: "#8791af" },
  xAxis: { label: { color: "#8791af" }, tickColor: "#8791af" },
  yAxis: { label: { color: "#8791af" }, tickColor: "#8791af" },
  legend: { label: { color: "#8791af" } },
};

registerTheme("myTheme", theme);

function ColumnChart({ categories, series, title }) {
  const chartRef = useRef(null);

  useEffect(() => {
    const container = chartRef.current;
    if (!container) return;

    // 데이터 유효성 체크
    if (!categories || categories.length === 0 || !series || series.length === 0) {
      return;
    }

    const data = { categories, series };
    const allValues = (series || []).flatMap((item) => item?.data || []);
    const rawMax = allValues.length ? Math.max(...allValues) : 0;
    const yAxisMax = rawMax > 0 ? Math.ceil(rawMax * 1.1) : 10;

    const options = {
      chart: { width: container.offsetWidth, height: 305, title },
      yAxis: { title: "Count", min: 0, max: yAxisMax },
      xAxis: { title: "Company" },
      legend: { align: "top" },
      theme: "myTheme",
    };

    const chart = columnChart(container, data, options);

    const handleResize = () => {
      chart.resize({ width: container.offsetWidth, height: 305 });
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chart.destroy();
    };
  }, [categories, series, title]);

  return <div ref={chartRef} style={{ width: "100%" }} />;
}

export default ColumnChart;